import {
  contactsLoading,
  contactsError,
  setContactsList,
} from "../../slices/contactsSlice.js";

import {
  getService,
  deleteAllService,
  deleteRowService,
  softDeleteService,
  softDeleteAllService,
  restoreRowService,
  restoreAllService,
} from "../../services/contacts.js";

export const getAction = () => async (dispatch) => {
  dispatch(contactsLoading());
  try {
    const response = await getService();
    if (response?.error) {
      dispatch(contactsError(response.error));
    } else {
      dispatch(setContactsList(response));
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  console.log("table: ", table);
  console.log("id: ", id);
  console.log("username: ", username);

  dispatch(contactsLoading());
  try {
    const response = await softDeleteService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
    } else {
      dispatch(
        contactsError(
          `Failed to soft delete row with ID ${id} in ${table} table`
        )
      );
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};

export const softDeleteAllAction =
  (table, type, username) => async (dispatch) => {
    console.log(username);

    dispatch(contactsLoading());
    try {
      const response = await softDeleteAllService(table, type, username);
      if (response?.message) {
        dispatch(getAction());
      } else {
        dispatch(
          contactsError(
            `Failed to delete records in ${table} table of type ${type}`
          )
        );
      }
    } catch (error) {
      dispatch(contactsError(error.message));
    }
  };

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(contactsLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
    } else {
      dispatch(
        contactsError(`Failed to delete row with ID ${id} in table ${table}`)
      );
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};

export const deleteAllAction = (table, type, username) => async (dispatch) => {
  dispatch(contactsLoading());
  try {
    const response = await deleteAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
    } else {
      dispatch(
        contactsError(
          `Failed to delete records in ${table} table of type ${type}`
        )
      );
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(contactsLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
    } else {
      dispatch(
        contactsError(`Failed to recover row with ID ${id} in ${table} table`)
      );
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};

export const restoreAllAction = (table, type, username) => async (dispatch) => {
  dispatch(contactsLoading());
  try {
    const response = await restoreAllService(table, username);
    if (response?.message) {
      dispatch(getAction());
    } else {
      dispatch(
        contactsError(
          `Failed to recover records in ${table} table of type ${type}`
        )
      );
    }
  } catch (error) {
    dispatch(contactsError(error.message));
  }
};
